import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryByAxios } from "@/redux/api/fetchBaseQueryHelper";
import _ from "lodash";

/**
 * https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#prepareheaders
 * here to learn more about the query
 * or see
 * `postSlice-example`, `userSlice-example`
 */
export const distributionApi = createApi({
	reducerPath: "distribution",
	baseQuery: fetchBaseQueryByAxios,
	endpoints: (builder) => ({
		getDistributions: builder.query({
			query: () => `/userDetail/queryUserDetailByRole?role_id=2`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		deleteDistribution: builder.mutation({
			query(id) {
				return {
					url: `/userDetail/deleteUserDetailById?user_detail_id=${id}`,
					method: "DELETE",
				};
			},
		}),
		addDistribution: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/userDetail/insertUserDetail",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		updateDistribution: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/userDetail/updateUserDetailById",
					method: "PUT",
					body: initialPost,
				};
			},
		}),
	}),
});

export const {
	useAddDistributionMutation,
	useDeleteDistributionMutation,
	useGetDistributionsQuery,
	useUpdateDistributionMutation,
} = distributionApi;
